import { Controller } from "@hotwired/stimulus"

// Attach to a <turbo-frame> to have it periodically reload itself (re-fetch
// its own src) -- for pages showing background progress (Amazon Ads
// backfill, onboarding's sync status) that would otherwise need a manual
// page refresh to see updated progress.
//
// Replaces a plain data-poll-interval="3000" attribute that used to sit on
// these frames with no JS anywhere actually reading it -- the frames never
// auto-updated at all; this was found while fixing the onboarding status
// page (see docs/multimarket.md).
export default class extends Controller {
  static values = { interval: { type: Number, default: 3000 } }

  connect() {
    this.timer = setInterval(() => this.element.reload(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }
}
